import { Box, SnackbarContent, Stack, TextField, Theme, Typography } from "@mui/material";
import { styled } from "@mui/material/styles";
import { COLORS } from "../../constants";

interface ContainerProps {
  zoomfactor: number;
}

export const TopTitleBox = styled(Box)(({ theme }) => ({
  display: "flex",
  gap: "24px",
}));

export const DemoSticker = styled(Box)(({ theme }) => ({
  backgroundColor: COLORS.DIDACTO_RED,
  color: "white",
  padding: "12px",
  borderRadius: "24px 0 24px 24px",
  fontFamily: "TisaSansPro-Bold",
}));

export const Level = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${50 * zoomfactor}px`,
  fontFamily: "TisaSansPro",
}));

export const StickerNew = styled(Typography)<ContainerProps>(({ theme, zoomfactor }) => ({
  fontSize: `${30 * zoomfactor}px`,
  fontFamily: "TisaSansPro",
  backgroundColor: COLORS.DIDACTO_BLUE,
  borderRadius: `0 ${25 * zoomfactor}px ${25 * zoomfactor}px ${25 * zoomfactor}px`,
  color: "white",
  display: "flex",
  justifyContent: "center",
  padding: `${10 * zoomfactor}px ${20 * zoomfactor}px`,
}));

export const NameExamTextField = styled(TextField)<ContainerProps>(({ theme, zoomfactor }) => ({
  "& .MuiInputBase-root": {
    fontSize: `${33 * zoomfactor}px`,
    fontFamily: "TisaSansPro",
  },
}));

export const StyledSnackbarContent = styled(SnackbarContent)(({ theme }) => ({
  backgroundColor: COLORS.DIDACTO_GREY,
  fontSize: "1.2rem",
  minWidth: "unset",
  color: "#fff",
}));

export const MenuStack = styled(Stack)<ContainerProps>(({ theme, zoomfactor }) => ({
  position: "absolute",
  top: `${30 * zoomfactor}px`,
  right: "12px",
  zIndex: "2",
  backgroundColor: "rgba(255, 255, 255, 0.8)",
}));

export const SelectObjectiveDialogInfoBox = styled(Typography)(({ theme }) => ({
  fontFamily: "TisaSansPro-Italic",
  color: COLORS.DIDACTO_GREY_FONT,
}));
